import { Header, HeaderTwo } from "../../components/Header"
import { Column, Row } from "../../components/Layout"
import { Sidebar } from "../../components/Sidebar"

import AmbevLogo from "../../assets/img/logo_ambev.png"
import { Empty } from "../../components/Empty"
import { Table } from "../../components/Table"
import { Navigate, useNavigate } from "react-router-dom"
import moment from "moment"

export const EvidenceScreen = ({
  evidenceData,
  tableDetails,
  sidebarOptions,
  control,
  contentType,
  onChange,
  setDetails,
}) => {
  const navigate = useNavigate()
  return (
    <>
      <HeaderTwo titlePage={"Evidências"} goBack={() => navigate(-1)} labelButton={"Voltar"} />
      <Row>
        <Sidebar
          title="Conteúdos"
          content={(evidenceData["posts"] || []).filter(
            (item) => !contentType || item.Trilha === contentType,
          )}
          selectOptions={sidebarOptions}
          setDetails={({ postId, year }) => {
            const newPostDetails = (evidenceData["details"] || []).find((item) => (
              item.muralId === postId && 
              moment(item?.date, 'YYYYMMDD').format("YYYY") == year
            ));

            setDetails(newPostDetails);
          }}
          control={control}
          onChange={onChange}
          data={(evidenceData["details"] || [])}
        />
        <Column className={"col-8"}>
          {tableDetails.length === 0 && <Empty label={"Selecione um conteúdo"} />}
          {evidenceData &&
            tableDetails.map((row, index) => {
              // if (!evidenceData[row.value]) return
              return (
                <Table
                  key={index}
                  title={row?.title}
                  data={row.data[row.value]}
                  hasBackground={index !== 0}
                  lineCaptions={row?.lineCaptions && row?.lineCaptions}
                  hasPaddingLeft={index !== 0}
                />
              )
            })}
        </Column>
      </Row>
    </>
  )
}
